export const regionsEtDepartements = {
  "Auvergne-Rhône-Alpes": [
    { code: "01", nom: "Ain" },
    { code: "03", nom: "Allier" },
    { code: "07", nom: "Ardèche" },
    { code: "15", nom: "Cantal" },
    { code: "26", nom: "Drôme" },
    { code: "38", nom: "Isère" },
    { code: "42", nom: "Loire" },
    { code: "43", nom: "Haute-Loire" },
    { code: "63", nom: "Puy-de-Dôme" },
    { code: "69", nom: "Rhône" },
    { code: "73", nom: "Savoie" },
    { code: "74", nom: "Haute-Savoie" },
  ],
  "Bourgogne-Franche-Comté": [
    { code: "21", nom: "Côte-d'Or" },
    { code: "25", nom: "Doubs" },
    { code: "39", nom: "Jura" },
    { code: "58", nom: "Nièvre" },
    { code: "70", nom: "Haute-Saône" },
    { code: "71", nom: "Saône-et-Loire" },
    { code: "89", nom: "Yonne" },
    { code: "90", nom: "Territoire de Belfort" },
  ],
  Bretagne: [
    { code: "22", nom: "Côtes-d'Armor" },
    { code: "29", nom: "Finistère" },
    { code: "35", nom: "Ille-et-Vilaine" },
    { code: "56", nom: "Morbihan" },
  ],
  "Centre-Val de Loire": [
    { code: "18", nom: "Cher" },
    { code: "28", nom: "Eure-et-Loir" },
    { code: "36", nom: "Indre" },
    { code: "37", nom: "Indre-et-Loire" },
    { code: "41", nom: "Loir-et-Cher" },
    { code: "45", nom: "Loiret" },
  ],
  Corse: [
    { code: "2A", nom: "Corse-du-Sud" },
    { code: "2B", nom: "Haute-Corse" },
  ],
  "Grand Est": [
    { code: "08", nom: "Ardennes" },
    { code: "10", nom: "Aube" },
    { code: "51", nom: "Marne" },
    { code: "52", nom: "Haute-Marne" },
    { code: "54", nom: "Meurthe-et-Moselle" },
    { code: "55", nom: "Meuse" },
    { code: "57", nom: "Moselle" },
    { code: "67", nom: "Bas-Rhin" },
    { code: "68", nom: "Haut-Rhin" },
    { code: "88", nom: "Vosges" },
  ],
  "Hauts-de-France": [
    { code: "02", nom: "Aisne" },
    { code: "59", nom: "Nord" },
    { code: "60", nom: "Oise" },
    { code: "62", nom: "Pas-de-Calais" },
    { code: "80", nom: "Somme" },
  ],
  "Île-de-France": [
    { code: "75", nom: "Paris" },
    { code: "77", nom: "Seine-et-Marne" },
    { code: "78", nom: "Yvelines" },
    { code: "91", nom: "Essonne" },
    { code: "92", nom: "Hauts-de-Seine" },
    { code: "93", nom: "Seine-Saint-Denis" },
    { code: "94", nom: "Val-de-Marne" },
    { code: "95", nom: "Val-d'Oise" },
  ],
  Normandie: [
    { code: "14", nom: "Calvados" },
    { code: "27", nom: "Eure" },
    { code: "50", nom: "Manche" },
    { code: "61", nom: "Orne" },
    { code: "76", nom: "Seine-Maritime" },
  ],
  "Nouvelle-Aquitaine": [
    { code: "16", nom: "Charente" },
    { code: "17", nom: "Charente-Maritime" },
    { code: "19", nom: "Corrèze" },
    { code: "23", nom: "Creuse" },
    { code: "24", nom: "Dordogne" },
    { code: "33", nom: "Gironde" },
    { code: "40", nom: "Landes" },
    { code: "47", nom: "Lot-et-Garonne" },
    { code: "64", nom: "Pyrénées-Atlantiques" },
    { code: "79", nom: "Deux-Sèvres" },
    { code: "86", nom: "Vienne" },
    { code: "87", nom: "Haute-Vienne" },
  ],
  Occitanie: [
    { code: "09", nom: "Ariège" },
    { code: "11", nom: "Aude" },
    { code: "12", nom: "Aveyron" },
    { code: "30", nom: "Gard" },
    { code: "31", nom: "Haute-Garonne" },
    { code: "32", nom: "Gers" },
    { code: "34", nom: "Hérault" },
    { code: "46", nom: "Lot" },
    { code: "48", nom: "Lozère" },
    { code: "65", nom: "Hautes-Pyrénées" },
    { code: "66", nom: "Pyrénées-Orientales" },
    { code: "81", nom: "Tarn" },
    { code: "82", nom: "Tarn-et-Garonne" },
  ],
  "Pays de la Loire": [
    { code: "44", nom: "Loire-Atlantique" },
    { code: "49", nom: "Maine-et-Loire" },
    { code: "53", nom: "Mayenne" },
    { code: "72", nom: "Sarthe" },
    { code: "85", nom: "Vendée" },
  ],
  "Provence-Alpes-Côte d'Azur": [
    { code: "04", nom: "Alpes-de-Haute-Provence" },
    { code: "05", nom: "Hautes-Alpes" },
    { code: "06", nom: "Alpes-Maritimes" },
    { code: "13", nom: "Bouches-du-Rhône" },
    { code: "83", nom: "Var" },
    { code: "84", nom: "Vaucluse" },
  ],
  "Outre-mer": [
    { code: "971", nom: "Guadeloupe" },
    { code: "972", nom: "Martinique" },
    { code: "973", nom: "Guyane" },
    { code: "974", nom: "La Réunion" },
    { code: "976", nom: "Mayotte" },
  ],
};
